import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { FlowMockupStyles, SpeakingMockup } from '@/pages/flow/FlowMockups'
import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import QuizLayout from './QuizLayout'

const TITLE = 'pages.quizOnboarding.preview.title'

export default function PreviewPage() {
  const { t } = useTranslation()
  const language = useSelectedLanguageName()

  return (
    <QuizLayout>
      <FlowMockupStyles />

      <div className="flex grow flex-col items-center justify-center gap-8">
        <SpeakingMockup />

        <div className="space-y-3 text-center">
          <p className="text-custom-black max-w-md text-xl font-bold text-balance">
            {t(TITLE, { language })}
          </p>
          <p className="mx-auto max-w-md text-[15px] leading-relaxed text-[#4a5568]">
            {t('pages.quizOnboarding.preview.body', { language })}
          </p>
        </div>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t(TITLE, { lng: 'en', language })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <ContinueButton />
      </Form>
    </QuizLayout>
  )
}
